/*
 * assets/vp-backnav.js
 * Guarda, no sessionStorage, de qual vitrine (Ofertas Especiais, Outlet,
 * etc.) o cliente clicou pra ir até um produto — usado pela section
 * vp-back-link.liquid na página do produto pra mostrar "← Voltar para
 * X" com o nome certo. A volta em si usa history.back(), não esse dado;
 * isso aqui só serve pra saber COMO rotular o link.
 */
(function () {
  if (window.__vpBackNavInit) return;
  window.__vpBackNavInit = true;

  function init() {
    document.querySelectorAll('[data-vp-section-label]').forEach(function (wrap) {
      var label = wrap.getAttribute('data-vp-section-label');
      if (!label) return;

      wrap.querySelectorAll('.vp-card').forEach(function (card) {
        card.addEventListener('click', function () {
          try {
            sessionStorage.setItem('vpBackNav', JSON.stringify({ label: label }));
          } catch (e) {}
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
